let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a97IR")).then(() => parcelRequire('dYUex'));